/** Card-only presentation tokens. These do not declare supported product types. */
export const POOL_CARD_PALETTES = {
  squares: {
    fill: "#f4c542",
    on: "#201b0a",
    light: "#765800",
    dark: "#f4c542",
  },
  stripCard: {
    fill: "#4bd38a",
    on: "#102619",
    light: "#12643b",
    dark: "#4bd38a",
  },
  survivor: {
    fill: "#69aaff",
    on: "#10233d",
    light: "#245da8",
    dark: "#69aaff",
  },
  pickem: { fill: "#f695ca", on: "#371326", light: "#9b2868", dark: "#f695ca" },
  brackets: {
    fill: "#ff8d89",
    on: "#391612",
    light: "#ac3030",
    dark: "#ff8d89",
  },
  unknown: {
    fill: "#b2b8b4",
    on: "#202820",
    light: "#535e56",
    dark: "#b2b8b4",
  },
} as const;

export function poolCardType(value: string): keyof typeof POOL_CARD_PALETTES {
  const key = value.toLowerCase().replace(/[^a-z]/g, "");
  if (key === "stripcard") return "stripCard";
  if (
    key === "squares" ||
    key === "survivor" ||
    key === "pickem" ||
    key === "brackets"
  )
    return key;
  return "unknown";
}
export function poolCardPalette(value: string) {
  return POOL_CARD_PALETTES[poolCardType(value)];
}
export const POOL_CARD_TYPE_PATHS: Record<
  keyof typeof POOL_CARD_PALETTES,
  string
> = {
  survivor: "M12 3l8 4v5c0 5-4 8-8 10-4-2-8-5-8-10V7z",
  squares: "M3 3h18v18H3z M9 3v18 M15 3v18 M3 9h18 M3 15h18",
  stripCard: "M6 3h12v18H6z M6 8h12 M6 13h12 M6 18h12",
  pickem: "M4 12l5 5L20 6",
  brackets: "M3 4h6v6H3 M3 14h6v6H3 M9 7h6v10H9 M15 12h6",
  unknown: "M12 3l9 9-9 9-9-9z",
};
/** Bundled vector fallback artwork; no external image service or league marks. */
const SPORT_PATHS: Record<string, string> = {
  football:
    "M3 21C0 8 8 0 21 3c3 13-5 21-18 18z M7 17L17 7 M8 13l3 3 M11 10l3 3 M14 7l3 3",
  basketball:
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20 M2 12h20 M12 2v20 M5 5q14 7 0 14 M19 5Q5 12 19 19",
  baseball:
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20 M6 4q8 8 0 16 M18 4q-8 8 0 16",
  soccer:
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20 M12 7l5 4-2 6H9l-2-6z M12 2v5 M17 11l5-2 M15 17l3 3 M9 17l-3 3 M7 11L2 9",
  hockey: "M5 3l7 15h8v3H9L2 4 M15 12h6v3h-6z",
  golf: "M7 21V3l12 5-12 5 M3 21h18",
};
export function poolCardSportPath(sport: string): string | null {
  return SPORT_PATHS[sport.toLowerCase()] ?? null;
}
